import React from 'react'
import '../../styles/kookal.css';
import backimage from '../../assets/resort-model-1.jpg'
import kookalBg from '../../assets/banner/land-view.jpg';
import Navbar from '../../components/common/Navbar/Navbar';
import logo from '../../assets/Avothar-black-logo.png'

const Kookal = () => {
    return (
        <div>
     
            <Navbar position="absolute" logo = {logo} buttonColor='dark' border="bottom" navColor="black" color="black"/>

            <section className="main-section pb-5 " id="main-section" style={{ backgroundImage: `url(${kookalBg})`,height:"60vh !important" ,backgroundPosition:"top"}}>
                <div className="container landing-margin  " data-aos="zoom-in-right" data-aos-duration="3000">
                    <div className="">
                        <div className="row pb-3">
                            <div className="col-lg-1 ps-3 pt-4 ">
                            
                            </div>
                            <div className="col-lg-8 pt-2">
                                <h1 style={{    color: "beige",textShadow: "3px 3px 17px black"}} className="hero-heading mb-3">
                                <span style={{ fontSize: '3rem' }}>“Own Your Land in the Hills, <br></br>Secure Your Future in Nature.”</span> <br />

                                </h1>
                                <h1 style={{fontSize: '1.6rem',color: "beige",textShadow: "3px 3px 17px black"}}>✨ Premium Gated Community</h1>
                                <h1 style={{fontSize: '1.6rem',color: "beige",textShadow: "3px 3px 17px black"}}>✨ 7.2-Meter internal roads </h1>
                                <h1 style={{fontSize: '1.6rem',color: "beige",textShadow: "3px 3px 17px black"}}>✨ Ready electricity & water facilities</h1>
                                <h1 style={{fontSize: '1.6rem',color: "beige",textShadow: "3px 3px 17px black"}}>✨ Ideal for dream villas & smart investments</h1>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
             <div className="container mt-5 mb-5 icon-session center">
                <div className="row">
                <div className="col-sm-12 col-lg-3" data-aos="fade-right">
                    <i class="fa-solid fa-mountain-sun icon"></i>
                    <div style={{ fontFamily: "'Poppins', sans-serif", paddingBottom: 8, fontWeight: 700, fontSize: '1.1rem' }} >
                    Premium Gated Community
                    </div>
                    <p style={{ fontSize: '1.1rem' }}>
                    Live in a secure, private, and nature-rich neighborhood.
                    </p>
                </div>
                <div className="col-sm-12 col-lg-3" data-aos="fade-up">
                    <i class="fa-solid fa-road icon"></i>
                    <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, paddingBottom: 8, fontSize: '1.1rem' }}>
                    7.2-Meter Internal Roads
                    </div>
                    <p style={{ fontSize: '1.1rem' }}>
                    Wide, well-planned roads for easy access and comfort.
                    </p>
                </div>
                <div className="col-sm-12 col-lg-3" data-aos="fade-left">
                    <i class="fa-sharp fa-solid fa-water icon"></i>
                    <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, paddingBottom: 8, fontSize: '1.1rem' }}>
                    Ready Electricity & Water
                    </div>
                    <p style={{ fontSize: '1.1rem' }}>
                    Fully equipped with essential utilities from day one.
                    </p>
                </div>
                <div className="col-sm-12 col-lg-3" data-aos="fade-left">
                    <i class="fa-sharp fa-solid fa-home icon"></i>
                    <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, paddingBottom: 8, fontSize: '1.1rem' }}>
                    Dream Villas & Smart Investments
                    </div>
                    <p style={{ fontSize: '1.1rem' }}>
                    Perfect to build your villa or grow your wealth.
                    </p>
                </div>
                </div>
            </div>
            <div className='kookal-page'>
            <section className='section-border-bottom'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 kookal-sec-1" >

                        </div>
                        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-5">
                            <div>
                                <h3 className='text-center' style={{
                                    marginBottom: '4rem',
                                }}>Welcome to Avothar - Where You Don't Just Invest, You Belong</h3>
                                <p className='text-center fs-4 font-time'>More than a holiday home - this is a movement toward meaningful ownership.
                                    Nestled in the untouched hills of Kookal, Kodaikanal, "AVOTHAR" is a premium investment opportunity where every investor becomes an Avothar a proud owner of a luxury villa plots inside a thoughtfully designed avocado farm retreat.</p>
                                <p className='text-center mt-5'><span style={{ backgroundColor: '#BE9765', color: '#000', padding: '0.7rem 0.3rem', border: '2px solid #F1E3F0', fontSize: '0.9rem' }}>
                                    DON'T WAIT TO INVEST, RATHER INVEST AND WAIT
                                </span></p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section className='section-border-bottom'>
                <div className="container mt-4">
                    <div className="row">
                        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-5">
                            <div>
                                <h3 className='text-center fs-2' style={{
                                    marginBottom: '4rem'
                                }}>LOCATION ADVANTAGE –<br />
                                    KOOKAL, KODAIKANAL</h3>
                                <ul className='fs-5 font-time' style={{ listStyleType: 'disc', paddingLeft: '1rem' }}>
                                    <li className='font-time fs-4'>Scenic valley surrounded by misty hills and Kookal Lake</li>
                                    <li className='font-time fs-4'>Peaceful, pollution-free environment</li>
                                    <li className='font-time fs-4'>Fast appreciating eco-tourism hub</li>
                                    <li className='font-time fs-4'>Strong demand for gated community projects</li>
                                    <li className='font-time fs-4'>Pleasant Climate Cool and refreshing weather all year.</li>
                                    <li className='font-time fs-4'>Poombarai Murugan Temple with in 7Kms</li>
                                    <li className='font-time fs-4'>Hotspots located near Kookal Lake, Water falls, trekking trails, View point, and eco-tourism hotspots.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 kookal-sec-2" >
                        </div>
                    </div>
                </div>
            </section >
            <section className='section-border-bottom'>
                <div className="container mt-4">
                    <div className="row">
                        <div className="col-md-6 kookal-sec-3" >
                        </div>
                        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-5">
                            <div>
                                <h3 className='text-center fs-2' style={{
                                    marginBottom: '4rem'
                                }}>WHY OWN YOUR HILL LAND NOW?</h3>
                                <ul>
                                    <li className='font-time fs-4'>Land scarcity in hill stations like Kodaikanal, Poombarai, Kookal pushing demand upwards</li>
                                    <li className='font-time fs-4'>Rising eco-tourism & wellness tourism fueling second-home demand</li>
                                    <li className='font-time fs-4'>Kookal identified as an upcoming resort hub (resorts, gated projects in pipeline)</li>
                                    <li className='font-time fs-4'>Safe haven investment: land historically appreciates faster than flats in these regions</li>
                                    <li className='font-time fs-4'>Urban heat rise & rising city temperatures driving strong urban interest in owning land in cooler hill stations</li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </section >
            
            <section className='section-border-bottom'>
                <div className="container mt-4">
                    <div className="row">
                        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-5">
                            <div>
                                <h3 className='text-center fs-2' style={{
                                    marginBottom: '4rem'
                                }}>PROJECT HIGHLIGHTS</h3>
                                <ul>
                                    <li className='font-time fs-4'>Total Area: 5.1 acres (with gated layout plan)</li>
                                    <li className='font-time fs-4'>Sale Plots ranging from 23 cents to 51 cents for area of 2.35 Acres</li>
                                    <li className='font-time fs-4'>Resort project inside community ensures value appreciation for 2.75 Acres</li>
                                    <li className='font-time fs-4'>Infrastructure planned: roads, fencing, water connection, plantations</li>
                                    <li className='font-time fs-4'>Farmland lifestyle with Avocado, Lemon & Banana orchards. Peaches and sheoaks integrated</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 kookal-sec-4" >
                        </div>
                    </div>
                </div>
            </section >
            <section className='section-border-bottom'>
                <div className="container mt-4">
                    <div className="row">
                        <div className="col-md-6 kookal-sec-5" >
                        </div>
                        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-5">
                            <div>
                                <h3 className='text-center' style={{
                                    marginBottom: '4rem'
                                }}>WHY AVOTHAR?</h3>
                                <ul>
                                    <li className='font-time fs-4'>Owned by Kodai Agriorg Pvt Ltd with proven track record in Eco Resorts, farmland & plantations</li>
                                    <li className='font-time fs-4'>Located in Kookal hills with breathtaking views, lake proximity, and cool climate</li>
                                    <li className='font-time fs-4'>Resort inside = constant footfall + visibility for appreciation</li>
                                    <li className='font-time fs-4'>Limited inventory = exclusivity & scarcity value</li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </section >
                    </div>

            <section className='section-border-bottom' >
                <div className="container mt-4">
                    <div className="row">
                        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-5" >
                            <div>
                                <h3 className='text-center' style={{
                                    marginBottom: '4rem'
                                }}>PLOT DETAILS</h3>
                                <ul>
                                    <li className='font-time fs-4'>Villa Plots in a Premium Gated Community -(Enquire for Price)/Cent - Kookal, Kodaikanal</li>
                                    <li className='font-time fs-4'>Fully secured community with gated access</li>
                                    <li className='font-time fs-4'>7-m wide well-laid internal roads for every plot</li>
                                    <li className='font-time fs-4'>Ready-to-use electricity connections</li>
                                    <li className='font-time fs-4'>Shared water facility for all plot owners</li>
                                    <li className='font-time fs-4'>Perfect for building your dream villa or as a smart long-term investment</li>
                                </ul>

                                <ul>
                                    <li className='font-time fs-4'>✅ Plot 1 & 2 – 51 Cents (Available)</li>
                                    <li className='font-time fs-4'>✅ Plot 4 – 23 Cents (Available)</li>
                                    <li className='font-time fs-4'>✅ Plot 5 – 23 Cents (Available)</li>
                                    <li className='font-time fs-4'>✅ Plot 6 – 23 Cents (Available)</li>
                                    <li className='font-time fs-4'>✅ Plot 7 – 23 Cents (Available)</li>
                                    <li className='font-time fs-4'>✅ Plot 8 – 23 Cents (Booked)</li>
                                    <li className='font-time fs-4'>❌ Plot 3 – 69 Cents (SOLD OUT)</li>
                                </ul>
                            </div>

                        </div>
                        <div className="col-md-6 kookal-sec-6" >
                        </div>
                    </div>
                </div>
            </section >
            <section className='section-border-bottom' style={{ backgroundImage: `url(${backimage})`, backgroundSize: 'cover', backgroundPosition: 'center' ,height:"90vh" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 text-white d-flex flex-column justify-content-end align-items-center"  style={{  height:"90vh"}}>
                            <div style={{ backgroundColor: 'rgba(36, 61, 22, 0.5)', borderRadius: '10px', padding: '2rem'}}>
                                <h3 className='text-center' style={{
                                    marginBottom: '2.5rem', fontFamily: `sans-serif`, fontWeight: '500'
                                }}>INVESTMENT ADVANTAGE</h3>
                                <ul>
                                    <li className='font-time fs-4'>Resort-backed gated community appreciation potential in 3-5 years</li>
                                    <li className='font-time fs-4'>Surrounding resort developments guarantee value uplift</li>
                                    <li className='font-time fs-4'>Scope for villa construction, holiday rentals, and resale</li>
                                    <li className='font-time fs-4'>Safe freehold farmland investment with title deed</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <footer >
                <div className="container-fluid">
                    <div className="row">
                       
                        <div className="col-md-12 d-flex flex-column justify-content-center align-items-center p-5">
                            <div>
                                <h3 className='text-center' style={{
                                    marginBottom: '4rem',fontWeight: '500'
                                }}>"LIMITED INVENTORY.
                                    PREMIUM LOCATION.
                                    RESORT-ANCHORED GROWTH."</h3>
                                <p className='text-start fs-5 font-time'> Contact: Avothar Farms & Stays - Kodai Agriorg Pvt Ltd.</p>
                                <p className='text-start fs-5 font-time'>finance@kodaiagriorg.com</p>
                                <p className='text-start fs-5 font-time'><span style={{ color: '#FF904D' }}>
                                   +91 98845 90109 | +91 98846 90109
                                </span></p>
                                <p className='text-start fs-5 font-time'>Invitation to site visit.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </footer>
        </div >
    )
}

export default Kookal